import React from "react";
import { useFormikContext } from "formik";
import getCourtById from "../helpers/getCourtById";
import { FlatApplciationType } from "../types";
import getCourtByPostcode from "../helpers/getCourtByPostcode";

const DynamicCourtName = () => {
  const { values } = useFormikContext<FlatApplciationType>();

  const court = React.useMemo(() => {
    if (values.CourtID) {
      return getCourtById(values.CourtID);
    } else if (values.appl_det_addr_postcode) {
      return getCourtByPostcode(String(values.appl_det_addr_postcode));
    }
    
    return null;
  }, [values.appl_det_addr_postcode, values.CourtID]);

  return court ? (
    <strong>{court.name}</strong>
  ) : (
    <>your local court</>
  );
};

export default DynamicCourtName;
